<template>
  <div class="about">
    <div class="aboutTitle">大会介绍</div>
    <div class="aboutEn">CONFERENCE INTRODUCTION</div>
    <div class="aboutBox">
      <div class="aboutBoxTitle">{{ obj.title }}</div>
      <div class="aboutBoxPara paraA">{{ obj.paraA }}</div>
      <div class="aboutBoxPara">{{ obj.paraB }}</div>
    </div>
    <img src="https://p4.ssl.qhimg.com/t110b9a9301cb0bb4f782f1b849.png" alt="" class="aboutBg" />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
const props = defineProps(['obj'])
const obj = props.obj || {}
// const obj = ref({
//   title: 'ISC.AI 2024',
//   paraA:
//     'ISC 2024第十二届互联网安全大会将于7月31日-8月1日在北京国家会议中心召开。作为全球数字安全行业的风向标，ISC始终紧扣时代命脉，为行业提供前瞻趋势和战略引领。面对当下AI大模型应用热潮，本届ISC大会将在延续安全基因的同时，全面升级为 ISC.AI 2024 ，致力成为AI大模型浪潮下的拓局者，开启“聚变元年”。',
//   paraB:
//     '本届大会深度聚焦 安全和AI 两大领域。一方面，大会将引领AI时代下的安全新脉动，助力数字安全的跃迁升级，另一方面将全面拥抱AI热潮，探索AI技术与全行业的共融创生，助推新质生产力发展，打造一场集行业前瞻对话、高峰技术研讨、先进成果展示、创新孵化大赛、产业人才培训于一体的全球顶尖盛会。'
// })
</script>

<style lang="scss" scoped>
.about {
  opacity: 1;
  background: #f3f3f3;
  padding: 0 16px 40px;
  &Title {
    font-family: Source Han Sans;
    font-size: 18px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-9 */
    color: #242933;
  }
  &En {
    font-family: Source Han Sans;
    font-size: 12px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    font-variation-settings: 'opsz' auto;
    /* Gray 中性/gray-7 */
    color: #8a9099;
    margin: 2px 0 16px;
  }
  &Box {
    z-index: 20;
    padding: 16px 12px;
    border-radius: 16px;
    opacity: 1;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(120px);
    &Title {
      font-family: Source Han Sans;
      font-size: 18px;
      font-weight: 500;
      line-height: 22px;
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-9 */
      color: #242933;
    }
    &Para {
      font-family: Source Han Sans;
      font-size: 12px;
      font-weight: normal;
      line-height: 22px;
      text-align: justify; /* 浏览器可能不支持 */
      letter-spacing: 0px;
      font-variation-settings: 'opsz' auto;
      /* Gray 中性/gray-8 */
      color: #525966;
    }
  }
  &Bg {
    width: 83px;
    position: absolute;
    bottom: 0;
    right: 0;
  }
}
.paraA {
  margin: 12px 0;
}
</style>
